import { AHEmptyScreen } from "arkh";
import React from "react";
import { Linking } from "react-native";

import { FormattedMessage } from "react-intl";
import { Lottie } from "../../components/Lottie";

export function PLUScreenUpsell() {
  return (
    <AHEmptyScreen
      title={
        <FormattedMessage
          description="PLU Upsell Title"
          defaultMessage="Time to use PLU?"
        />
      }
      subtitle={
        <FormattedMessage
          description="PLU Upsell Subtitle"
          defaultMessage="Want to use the cash register mode? Gain access to a digital PLU book with images and a smart search function. You can easily add new items with images and PLUs from your mobile device or computer. Contact our support, and we'll get started!"
        />
      }
      illustration={
        <Lottie autoPlay loop source={require("./lottie-cashier.json")} />
      }
      helpLinks={
        <>
          <AHEmptyScreen.Link
            icon="email"
            text="support@storesprint.app"
            onPress={() => {
              Linking.openURL("mailto:support@storesprint.app");
            }}
          />
          <AHEmptyScreen.Link
            icon="phone"
            text="010 147 90 12"
            onPress={() => {
              Linking.openURL("tel:+46101479012");
            }}
          />
        </>
      }
    />
  );
}
